import { render, staticRenderFns } from "./SendMessageToChatActionSetupView.vue?vue&type=template&id=4aafdd12&scoped=true&"
import script from "./SendMessageToChatActionSetupView.vue?vue&type=script&lang=ts&"
export * from "./SendMessageToChatActionSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aafdd12",
  null
  
)

export default component.exports